import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { useGuestCart } from "../context/GuestCartContext";
import { saveGuestOrder } from "../utils/guestOrderStorage";

export default function GuestStripePaymentSuccess() {
  const navigate = useNavigate();
  const { guestCart, clearGuestCart } = useGuestCart();
  const [state, setState] = useState({ loading: true, error: "", order: null });

  useEffect(() => {
    let active = true;
    const run = async () => {
      const sessionId = new URLSearchParams(window.location.search).get("session_id");
      if (!sessionId) {
        if (active) setState({ loading: false, error: "Payment information was not found.", order: null });
        return;
      }
      try {
        const response = await api.post("/api/guest/stripe/finalize-checkout/", { session_id: sessionId });
        if (!active) return;
        const savedOrder = saveGuestOrder(response.data, guestCart);
        clearGuestCart();
        setState({ loading: false, error: "", order: savedOrder || response.data });
      } catch (err) {
        if (active) setState({ loading: false, error: err.response?.data?.detail || err.message || "Payment could not be confirmed.", order: null });
      }
    };
    run();
    return () => { active = false; };
  }, [clearGuestCart, guestCart]);

  return <div className="min-h-screen bg-[#F6F0E6] flex items-center justify-center p-5"><div className="w-full max-w-md rounded-[2rem] bg-white p-8 text-center shadow-[0_25px_70px_rgba(57,45,35,0.10)]">
    {state.loading && <><div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-[#DDE8E5] border-t-[#0F766E]" /><h1 className="mt-5 text-xl font-semibold text-[#332A24]">Processing your payment</h1><p className="mt-2 text-sm text-[#76695D]">Please wait while we confirm your Stripe payment.</p></>}
    {!state.loading && state.error && <><h1 className="text-2xl font-semibold text-[#332A24]">Payment could not be confirmed</h1><p className="mt-3 text-sm text-red-600">{state.error}</p><button onClick={() => navigate("/cart")} className="mt-7 w-full rounded-xl bg-[#0F766E] py-3 text-white">Return to Cart</button></>}
    {!state.loading && !state.error && <><div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#E2F0ED] text-2xl text-[#0F766E]">✓</div><h1 className="mt-5 text-2xl font-semibold text-[#332A24]">Payment successful</h1><p className="mt-2 text-sm text-[#76695D]">Your order has been placed successfully.</p>{state.order && <div className="mt-6 border-t pt-5 text-sm"><div className="flex justify-between"><span>Order</span><strong>{state.order.order_number}</strong></div><div className="mt-3 flex justify-between"><span>Total</span><strong className="text-[#0F766E]">${Number(state.order.total_amount).toFixed(2)}</strong></div></div>}<button onClick={() => navigate("/orders")} className="mt-7 w-full rounded-xl bg-[#0F766E] py-3 text-white">View My Orders</button></>}</div></div>;
}
